import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CommonButton from '../button/Button'; // Adjust path as needed

const DeleteConfirmationModal = ({ open, onClose, onClick, title, message }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="delete-confirmation-dialog-title"
            aria-describedby="delete-confirmation-dialog-description"
            maxWidth="sm"
            fullWidth
            sx={{
                padding: '20px',
                '& .MuiDialog-paper': {
                    width: '500px',
                },
            }}
        >
            <DialogContent>
                <DialogContentText
                    id="delete-confirmation-dialog-description"
                    sx={{
                        fontFamily: 'poppins',
                        textAlign: 'center',
                        paddingTop: '10px',
                    }}
                >
                    <ErrorOutlineIcon
                        sx={{
                            fontSize: '5rem',
                            color: '#FFDB8C',
                            margin: '5px',
                        }}
                    />
                </DialogContentText>

                <DialogTitle
                    id="delete-confirmation-dialog-title"
                    className="text-center"
                    sx={{
                        fontWeight: 500,
                        fontFamily: 'poppins',
                        fontSize: '25px',
                        paddingBottom: '4px',
                    }}
                >
                    {title || 'Are You Sure?'}
                </DialogTitle>

                <DialogContentText
                    id="delete-confirmation-dialog-description"
                    className="text-center"
                    sx={{ fontFamily: 'poppins' }}
                >
                    {message || 'You won\'t be able to revert this!'}
                </DialogContentText>
            </DialogContent>

            <DialogActions
                className="stammdaten-confirm-btn"
                sx={{
                    display: {
                        xs: 'block',
                        sm: 'flex',
                    },
                    justifyContent: 'center',
                    items: 'center',
                    paddingTop: '1rem',
                    paddingBottom: '2.5rem',
                }}
            >
                <CommonButton text="Yes, delete it!" onClick={onClick} />
                <CommonButton
                    text="Cancel"
                    onClick={onClose}
                    bgColor="linear-gradient(90deg, #E14A4A 0%, #FF4848 100%);"
                />
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmationModal;
